var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 20,
    height: 20,
    transform: "translate(980 -57)",
    fill: "#42506f",
    stroke: "#42506f",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_113",
    "data-name": "Mask Group 113",
    transform: "translate(-980 57)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(972.107 -64.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M19.358,17.952l8.268-8.268A1,1,0,0,0,26.22,8.278l-8.268,8.268L9.684,8.268A1,1,0,0,0,8.268,9.684l8.278,8.268L8.268,26.22a1,1,0,1,0,1.406,1.406l8.278-8.268,8.268,8.268a1,1,0,0,0,1.406-1.406Z",
    fill: "#42506f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDark);
export default __webpack_public_path__ + "static/media/closeDark.466adf3875b3c6fd1c4ec78fc5a5d95d.svg";
export { ForwardRef as ReactComponent };